import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {NGXLogger} from 'ngx-logger';
import {ConfirmationService, MessageService} from 'primeng/api';
import {AssetGroupService} from '../../../../_services/asset-group-service';
import {AssetGroupResponse} from '../../../../_models/asset-group.model';

@Component({
    selector: 'acabim-admin-update-asset-group',
    templateUrl: './update-asset-group.component.html',
    styleUrls: ['./update-asset-group.component.scss']
})
export class UpdateAssetGroupComponent implements OnInit, OnDestroy {

    @Output() completed = new EventEmitter<string>();
    @Input() public assetGroupDetails: AssetGroupResponse | null = null;
    loading = false;
    assetGroupForm: FormGroup | undefined;
    currentAsset: AssetGroupResponse | null = null;
    private _doSubmit = true;
    private _currentProcess: Subscription = new Subscription();

    constructor(
        private readonly logger: NGXLogger,
        private readonly messageService: MessageService,
        private assetGroupService: AssetGroupService,
        private confirmationService: ConfirmationService
    ) {
    }

    ngOnInit(): void {
        if (this.assetGroupDetails !== null && this.assetGroupDetails.id !== null) {
            this._currentProcess = this.assetGroupService.getAssetGroup(this.assetGroupDetails.id).subscribe(
                ct => {
                    this.currentAsset = ct;
                    this.initForm();
                }
            );
        }
    }

    ngOnDestroy(): void {
        this._currentProcess.unsubscribe();
    }

    private initForm(): void {
        if (this.currentAsset != null) {
            this.assetGroupForm = new FormGroup({
                name: new FormControl(this.currentAsset.name, Validators.required),
                description: new FormControl(this.currentAsset.description)
            });
        }
    }

    onAssetGroupUpdateSubmit(): void {
        this.loading = true;
        if (typeof this.assetGroupForm !== 'undefined') {
            if (this._doSubmit) {
                this.upsertAssetType();
            }
        }
    }

    onAssetGroupDeleteSubmit(): void {
        this.confirmationService.confirm({
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.onAssetGroupDeleteConfirmed();
            },
            reject: () => {
                this.onRejectDeletion();
            }
        });
    }

    onRejectDeletion(): void {
        this.messageService.clear('assetGroupConfirmDeletion');
    }

    onAssetGroupDeleteConfirmed(): void {
        this.loading = true;
        if (this.assetGroupForm) {
            if (this._doSubmit && this.currentAsset) {
                this._currentProcess = this.assetGroupService.deleteAssetGroup(this.currentAsset.id).subscribe(
                    result => {
                        console.log(result);
                        this.completed.emit('deleted');
                        this.loading = false;
                    }
                );
                this.upsertAssetType();
            }
        }
    }

    private upsertAssetType(): void {
        if (this.assetGroupForm && this.currentAsset) {

            this.logger.debug('[UpdateAssetGroupComponent] Updating existing asset type');
            this._currentProcess = this.assetGroupService.upsertAssetGroup(
                this.assetGroupForm.value.name,
                this.assetGroupForm.value.description,
                this.currentAsset.id.toString()
            ).subscribe(newAssetGroup => {
                this.logger.debug('[UpdateAssetGroupComponent] Asset type updated successfully: ', newAssetGroup.id);
                this.initForm();
                this.completed.emit('updated');
                this.loading = false;
                console.log('Upsert: updated');
            }, (error: any) => {
                this.logger.debug('[UpdateAssetGroupComponent] Asset type failed to update');
                this.logger.error(error);
                this.loading = false;
            });
        }
    }

    onCancel(): void {
        this.logger.debug('[UpdateAssetGroupComponent] Update asset group modal Cancelled');
        console.log('Upsert: cancelling');
        this.completed.emit('cancelled');
    }
}
